// src/ui/navigation/useAppNavigate.ts
import { type NavigateOptions, type RegisteredRouter, useNavigate } from "@tanstack/react-router";

type Direction = "forward" | "back" | "none";

export function useAppNavigate() {
  const navigate = useNavigate();

  return <TTo extends string | undefined>(
    options: NavigateOptions<RegisteredRouter, string, TTo, string, string> & {
      direction?: Direction;
      viewTransition?: boolean | { types?: string[] };
    },
  ) => {
    const { direction = "forward", viewTransition, ...rest } = options;

    return navigate({
      ...rest,
      viewTransition: viewTransition ?? (direction === "none" ? false : { types: [direction] }),
    } as NavigateOptions);
  };
}
